import TournamentDetails from './TournamentDetails';

export default TournamentDetails;

export { type Props, type PageProps } from './types';
